<template>
  <div class="unselect flex aic df-tabs por">
    <div class="curr-type csp por" @click="valueChange(format(i))" :class="{active: +value === format(i)}"
         v-for="(text, i) in tabs" :key="i">
      <span>{{text.name || text}}</span>
      <i class="abs-c type-line" :style="{width: lineWidth + 'px'}"></i>
    </div>
    <div class="line w100 poa l0"></div>
  </div>
</template>

<script>
  export default {
    name: "DfTabs",
    props: {
      value: {
        type: Number,
        required: true,
      },
      lineWidth: {
        type: Number,
      },
      tabs: {
        type: Array,
        default() {
          return [];
        },
      },
      format: {
        type: Function,
        default(i) {
          return i;
        },
      }
    },
    data() {
      return {};
    },
    methods: {
      valueChange(i) {
        if (i === this.value) {
          return;
        }
        this.value = i;
        this.$emit('input', i);
        this.$emit('change', i, this.tabs[i]);
      },
    }
  }
</script>

<style scoped lang="less">
  .df-tabs {
    margin-bottom: 24px;
    padding: 9px 0 17px 14px;
    border-color: #fff;
    font-size: 18px;
    color: #666f7a;
    transition: color .3s;
    .type-line {
      bottom: -17px;
      width: 24px;
      height: 3px;
      background: #1177ff;
      border-radius: 3px;
      opacity: 0;
      transition: opacity .3s;
    }
    .active {
      color: #1177ff;
      .type-line {
        opacity: 1;
      }
    }
    > :not(:first-child) {
      margin-left: 30px;
    }

    .line {
      top: 100%;
      margin: 0;
      height: 1px;
      background-color: #eee;
    }
  }
</style>